'use client';

import { useSidebarPadding } from '@/hooks/useSidebarPadding';

export const SidebarAwareLayout = () => {
  useSidebarPadding();

  return null;
};
